<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      :option="option"
      :table-loading="tableLoading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permission.device_maintenance_complete_audit_export !== false"
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>

      <template slot="maintenanceType" slot-scope="{ row }">
        <el-tag :type="maintenanceTypeTag(row.maintenanceType)" size="small">{{ maintenanceTypeLabel(row.maintenanceType) }}</el-tag>
      </template>
      <template slot="planDate" slot-scope="{ row }">
        {{ formatDate(row.planDate) }}
      </template>
      <template slot="startTime" slot-scope="{ row }">
        {{ formatDateTime(row.startTime) }}
      </template>
      <template slot="endTime" slot-scope="{ row }">
        {{ formatDateTime(row.endTime) }}
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleDetail(row)">详情</el-button>
        <el-button
          v-if="permission.device_maintenance_complete_audit_audit !== false"
          type="text"
          size="small"
          icon="el-icon-document-checked"
          @click="handleAudit(row)"
        >
          审核
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="维保计划详情" :visible.sync="detailDialogVisible" width="650px" :append-to-body="true">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="计划编号">{{ detailData.planNo }}</el-descriptions-item>
        <el-descriptions-item label="设备名称">{{ detailData.deviceName }}</el-descriptions-item>
        <el-descriptions-item label="执行人">{{ detailData.executorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="计划日期">{{ formatDate(detailData.planDate) }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ formatDateTime(detailData.startTime) }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ formatDateTime(detailData.endTime) }}</el-descriptions-item>
        <el-descriptions-item label="维保结果" :span="2">{{ detailData.result || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button size="small" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="审核维保完成" :visible.sync="auditDialogVisible" width="650px" :append-to-body="true" :close-on-click-modal="false">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="计划编号">{{ auditForm.planNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备名称">{{ auditForm.deviceName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="执行人">{{ auditForm.executorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="计划日期">{{ formatDate(auditForm.planDate) }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ formatDateTime(auditForm.startTime) }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ formatDateTime(auditForm.endTime) }}</el-descriptions-item>
        <el-descriptions-item label="维保结果" :span="2">{{ auditForm.result || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ auditForm.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核备注" :span="2">
          <el-input v-model="auditForm.auditRemark" type="textarea" :rows="3" placeholder="请输入审核备注（可选）" />
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button type="danger" size="small" :loading="auditSubmitting" @click="handleAuditSubmit(2)">驳 回</el-button>
        <el-button type="success" size="small" :loading="auditSubmitting" @click="handleAuditSubmit(1)">通 过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPendingAudits, auditComplete, exportCompleteAuditExcel } from './api'
import { downloadXls } from '@/util/util'

export default {
  name: 'MaintenanceCompleteAudit',
  data() {
    return {
      tableLoading: false,
      exportLoading: false,
      allData: [],
      data: [],
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        ...this.$store.state.publicOption,
        searchMenuSpan: 18,
        searchMenuPosition: 'right',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 150,
        stripe: true,
        column: [
          {
            label: '计划编号',
            prop: 'planNoSearch',
            type: 'input',
            search: true,
            hide: true,
            searchPlaceholder: '计划编号',
            searchSpan: 6,
          },
          {
            label: '设备名称',
            prop: 'deviceNameSearch',
            type: 'input',
            search: true,
            hide: true,
            searchPlaceholder: '设备名称',
            searchSpan: 6,
          },
          {
            label: '计划日期',
            prop: 'planDateRange',
            type: 'date',
            searchRange: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            search: true,
            hide: true,
            searchSpan: 9,
          },
          {
            label: '完成时间',
            prop: 'endTimeRange',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            search: true,
            hide: true,
            searchSpan: 6,
          },
          { label: '计划编号', prop: 'planNo', width: 160, align: 'center' },
          { label: '设备名称', prop: 'deviceName', minWidth: 150, align: 'center', overHidden: true },
          { label: '维保类型', prop: 'maintenanceType', width: 100, align: 'center', slot: true },
          { label: '计划日期', prop: 'planDate', width: 110, align: 'center', slot: true },
          { label: '执行人', prop: 'executorName', width: 100, align: 'center' },
          { label: '开始时间', prop: 'startTime', width: 160, align: 'center', slot: true },
          { label: '结束时间', prop: 'endTime', width: 160, align: 'center', slot: true },
          { label: '维保结果', prop: 'result', minWidth: 180, align: 'center', overHidden: true },
        ],
      },
      detailDialogVisible: false,
      detailData: {},
      auditDialogVisible: false,
      auditSubmitting: false,
      auditForm: {
        id: null,
        planNo: '',
        deviceName: '',
        executorName: '',
        planDate: '',
        startTime: '',
        endTime: '',
        result: '',
        remark: '',
        auditRemark: '',
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'permission']),
  },
  methods: {
    buildQueryParams(params = this.query) {
      const query = params || {}
      const planRange = query.planDateRange || []
      const endRange = query.endTimeRange || []
      const body = {
        status: 4,
        current: this.page.currentPage,
        size: this.page.pageSize,
      }
      if (query.planNoSearch) body.planNo = query.planNoSearch
      if (query.deviceNameSearch) body.deviceName = query.deviceNameSearch
      if (planRange.length === 2) {
        body.startDate = planRange[0]
        body.endDate = planRange[1]
      }
      if (endRange.length === 2) {
        body.endTimeStart = endRange[0]
        body.endTimeEnd = endRange[1]
      }
      return body
    },
    loadData() {
      this.tableLoading = true
      getPendingAudits(this.buildQueryParams())
        .then((res) => {
          const body = res && res.data
          const result = body && body.data != null ? body.data : body
          let audits = result && result.records != null ? result.records : result
          if (!Array.isArray(audits)) audits = []
          this.allData = audits.filter((item) => item.status === 4)
          this.data = this.allData
          this.page.total = result && result.total != null ? Number(result.total) : this.allData.length
        })
        .catch(() => {
          this.allData = []
          this.data = []
          this.page.total = 0
          this.$message.error('获取完成审核列表失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    applyFilter() {
      const query = this.query || {}
      const planNo = (query.planNoSearch || '').toLowerCase()
      const deviceName = (query.deviceNameSearch || '').toLowerCase()
      const planRange = query.planDateRange || []
      const endRange = query.endTimeRange || []
      let list = this.allData.slice()
      if (planNo) {
        list = list.filter((item) => String(item.planNo || '').toLowerCase().indexOf(planNo) > -1)
      }
      if (deviceName) {
        list = list.filter((item) => String(item.deviceName || '').toLowerCase().indexOf(deviceName) > -1)
      }
      if (planRange.length === 2) {
        list = list.filter((item) => this.isDateInRange(item.planDate, planRange[0], planRange[1]))
      }
      if (endRange.length === 2) {
        list = list.filter((item) => this.isDateInRange(item.endTime, endRange[0], endRange[1]))
      }
      this.page.total = list.length
      const start = (this.page.currentPage - 1) * this.page.pageSize
      this.data = list.slice(start, start + this.page.pageSize)
    },
    searchChange(params, done) {
      this.query = params || {}
      this.page.currentPage = 1
      this.loadData()
      done()
    },
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.loadData()
    },
    refreshChange() {
      this.loadData()
    },
    async handleExport() {
      const total = this.page.total || 0
      if (total < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      const maxRows = 10000
      if (total > maxRows) {
        this.$message.warning(`当前最多导出 ${maxRows} 条，请缩小筛选范围后重试`)
        return
      }
      this.exportLoading = true
      try {
        const params = this.buildQueryParams()
        delete params.current
        delete params.size
        const res = await exportCompleteAuditExcel(params)
        downloadXls(res.data, `维保完成审核_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
      this.loadData()
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.page.currentPage = 1
      this.loadData()
    },
    handleDetail(row) {
      this.detailData = Object.assign({}, row)
      this.detailDialogVisible = true
    },
    handleAudit(row) {
      this.auditForm = {
        id: row.id,
        planNo: row.planNo || '',
        deviceName: row.deviceName || '',
        executorName: row.executorName || '',
        planDate: row.planDate || '',
        startTime: row.startTime || '',
        endTime: row.endTime || '',
        result: row.result || '',
        remark: row.remark || '',
        auditRemark: '',
      }
      this.auditDialogVisible = true
    },
    getCurrentAuditor() {
      const u = this.userInfo || {}
      return {
        auditorId: u.user_id || u.userId || u.id,
        auditorName: u.real_name || u.realName || u.name || u.nick_name || u.nickName || u.account || '',
      }
    },
    handleAuditSubmit(auditResult) {
      const auditor = this.getCurrentAuditor()
      if (!auditor.auditorId || !auditor.auditorName) {
        this.$message.warning('未获取到当前登录人员信息，请重新登录后再审核')
        return
      }
      this.auditSubmitting = true
      auditComplete(this.auditForm.id, auditResult, auditor.auditorId, auditor.auditorName, this.auditForm.auditRemark)
        .then((res) => {
          const body = res && res.data
          if (body && (body.code === 200 || body.success)) {
            this.$message.success(auditResult === 1 ? '维保完成已审核通过' : '已驳回')
            this.auditDialogVisible = false
            this.loadData()
          } else {
            this.$message.error((body && body.msg) || '操作失败')
          }
        })
        .catch((e) => {
          this.$message.error((e && e.message) || '操作失败')
        })
        .finally(() => {
          this.auditSubmitting = false
        })
    },
    maintenanceTypeTag(type) {
      if (type === 'routine') return 'info'
      if (type === 'seasonal') return 'warning'
      return 'primary'
    },
    maintenanceTypeLabel(type) {
      const map = { routine: '日常维保', periodic: '定期维保', seasonal: '季节性维保' }
      return map[type] || type || '-'
    },
    isDateInRange(value, start, end) {
      const date = this.formatDate(value)
      if (!date || date === '-') return false
      return date >= start && date <= end
    },
    formatDate(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val.slice(0, 10)
      const date = new Date(val)
      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)
      return `${year}-${month}-${day}`
    },
    formatDateTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      const date = new Date(val)
      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)
      const hour = (`0${date.getHours()}`).slice(-2)
      const minute = (`0${date.getMinutes()}`).slice(-2)
      const second = (`0${date.getSeconds()}`).slice(-2)
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
  },
}
</script>

<style scoped>
::v-deep .el-table {
  font-size: 13px;
}
</style>
